import { ScrollTrigger } from "gsap/ScrollTrigger"

import initSectionStage from "./sectionStage.js"
import initSectionBentoStage from "./sectionBentoStage.js"

// All other section animations are loaded on demand: each module is only
// fetched when a matching root selector is present in the DOM. Keep the
// selector strings in sync with the `toArray()` / `querySelector` calls
// inside each animation module.
const LAZY_SECTION_ANIMATIONS = [
    { selector: ".section-pinned-media", loader: () => import("./sectionPinnedMedia.js") },
    { selector: ".section-text-image-scroll-slider", loader: () => import("./sectionTextImageScrollSlider.js") },
    { selector: ".section-text-on-image", loader: () => import("./sectionTextOnImage.js") },
    { selector: ".section-product-teaser", loader: () => import("./sectionProductTeaser.js") },
    { selector: '.section-text-media[data-effect="parallax"]', loader: () => import("./sectionTextMedia.js") },
    { selector: ".section-card-grid, .section-team", loader: () => import("./sectionCards.js") },
    { selector: ".section-form", loader: () => import("./sectionForm.js") },
]

export function initSectionAnimations() {
    initSectionBentoStage()

    const loaders = LAZY_SECTION_ANIMATIONS
        .filter(({ selector }) => document.querySelector(selector))
        .map(({ loader }) => loader().then(({ default: init }) => init()))

    Promise.allSettled(loaders).then(() => ScrollTrigger.refresh())
}
